import { render, staticRenderFns } from "./ImprovedSurveyPreview.vue?vue&type=template&id=81483d62&scoped=true&"
import script from "./ImprovedSurveyPreview.vue?vue&type=script&lang=js&"
export * from "./ImprovedSurveyPreview.vue?vue&type=script&lang=js&"
import style0 from "./ImprovedSurveyPreview.vue?vue&type=style&index=0&id=81483d62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81483d62",
  null
  
)

export default component.exports